import React from "react";
import { useRouteLoaderData } from "react-router-dom";
import {
  userUpdate,
  userUpdateLongDescription,
  userUpdateShortDescription,
} from "../../../../../api/user";
import UserForm from "./UserForm";

const userUpdateAction = async ({ request }) => {
  const formData = await request.formData();

  const userEntityId = formData.get("userEntityId");
  const submission = {
    userEntityId,
    administrator: formData.get("administrator") === "on",
    title: formData.get("title"),
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    phone: formData.get("phone"),
    timezone: formData.get("timezone"),
    url: formData.get("url"),
    linkedinUserId: formData.get("linkedinUserId"),
    facebookUserId: formData.get("facebookUserId"),
    gmailUserId: formData.get("gmailUserId"),
    skypeUserId: formData.get("skypeUserId"),
    address1: formData.get("address1"),
    address2: formData.get("address2"),
    city: formData.get("city"),
    state: formData.get("state"),
    postal: formData.get("postal"),
    showOrder: formData.get("showOrder"),
    reminders: formData.get("reminders"),
    useHtml: formData.get("useHtml") === "on",
  };

  const oldShortDescription = formData.get("oldShortDescription");
  const newShortDescription = formData.get("shortDescription");
  if (encodeURIComponent(newShortDescription) !== oldShortDescription) {
    await userUpdateShortDescription(userEntityId, newShortDescription);
  }

  const oldLongDescription = formData.get("oldLongDescription");
  const newLongDescription = formData.get("longDescription");
  if (encodeURIComponent(newLongDescription) !== oldLongDescription) {
    await userUpdateLongDescription(userEntityId, newLongDescription);
  }

  return await userUpdate({ ...submission });
};

const UserUpdateForm = () => {
  const {
    user,
    shortDescription,
    longDescription,
  } = useRouteLoaderData("adminUser");

  return (
    <UserForm
      user={user}
      shortDescription={shortDescription}
      longDescription={longDescription}
    />
  );
};

export { userUpdateAction };
export default UserUpdateForm;